import { render, staticRenderFns } from "./BillPayment.vue?vue&type=template&id=774d3bb3&"
import script from "./BillPayment.vue?vue&type=script&lang=js&"
export * from "./BillPayment.vue?vue&type=script&lang=js&"
import style0 from "./BillPayment.vue?vue&type=style&index=0&id=774d3bb3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports